import Col from '../../../components/Col';
import { Table } from '../../../components';

import React, { Fragment } from 'react';

const colSpan = 1;

const TotalCellsColGroup = () => (
  <colgroup>
    <Col /* Total */ width="4em" />
  </colgroup>
);

const TotalCellsHeader1 = () => (
  <Table.HeaderCell colSpan={colSpan}>Total</Table.HeaderCell>
);

const TotalCellsHeader2 = () => (
  <Fragment>
    <Table.HeaderCell>=</Table.HeaderCell>
  </Fragment>
);

const TotalCells = ({ row }) => (
  <Fragment>
    <Table.Cell>
      <strong>{row.total === 0 ? '---' : row.total}</strong>
    </Table.Cell>
    {/*
      <Table.Cell>
        <Label circular basic>
          12
        </Label>
      </Table.Cell>
      */}
  </Fragment>
);

TotalCells.ColGroup = TotalCellsColGroup;
TotalCells.Header1 = TotalCellsHeader1;
TotalCells.Header2 = TotalCellsHeader2;
TotalCells.colSpan = colSpan;

export default TotalCells;



// WEBPACK FOOTER //
// ./src/terminals/Director/Protocol/TotalCells.js